module.exports = __webpack_public_path__ + "img/fans.54d9d341.svg";